(ns ycweb.app.website.registry.discountmanager
  (:require
   [ycweb.components.flow :as flow]
   [rum.core :as rum]
   [ycweb.util.core :as u]
   [ycweb.components.headings :as headings]
   [ycweb.app.website.registry.common :as awr.cmn]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.components.toaster :as toaster]
   [ycweb.app.website.website :as website]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]))

(defn voucher-line [voucher]
  (let [redeemer (:item-line/user voucher)]
    [:tr.yc-tr
     [:th.yc-th
      {:scope "row" :data-th "Voucher Number:"}
      [:b (:voucher/code voucher)]]
     [:td.yc-td
      [:span.yc-td__faux-table
       {:data-th "Status"}
       (if (:voucher/redeemed? voucher)
         [:span.yc-td__faux-td
          [:span.text-status--success [:b "Redeemed "]]
          (str (:user/first-name redeemer) " " (:user/last-name redeemer))]
         [:span.yc-td__faux-td "Not Redeemed yet"])]]]))

;; Family Discount Manager
(rum/defc registry-discount-manager < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        registry (cmn/curact process-atom [:registry])
        vouchers (cmn/curact process-atom [:vouchers])]
    [:<>
     (awr.cmn/registry-banner app-atom registry)
     (awr.cmn/registry-manage-nav app-atom :familydiscount registry)
     [:div
      {:class (u/bem :yc-section [:standard-underline])}
      [:div.yc-intro-text
       (headings/heading "Your Family Discount Vouchers"
         {:type :h1
          :size :large
          :center true})
       [:p.yc-paragraph
        "Forward the voucher codes below to three of your guests. They'll each receive 10% off any gift purchased from your registry, provided they spend R850 or more."]]]
     [:div.yc-section
      (feedback/feedback-raw :info
        {:title "Each 10% discount voucher can only be used once and by one guest, and is limited to your registry."
         :size :small
         :class :u-max-width-720})]
     [:div
      {:class (u/bem :yc-section [:large])}
      [:div.u-block-center.u-max-width-720
       [:table.yc-table
        [:caption.yc-table-caption.hidden-from-view
         "A Summary of Your 10% Off Family Discount Vouchers"]
        [:colgroup [:col {:style {:width "240px"}}] [:col]]
        [:thead.yc-thead
         [:tr.yc-tr
          [:th.yc-th {:scope "col"} "Voucher Number"]
          [:th.yc-th {:scope "col"} "Redemption Status"]]]
        [:tbody.yc-tbody
         (map voucher-line vouchers)
         (toaster/loading-overlay app-atom :web.registry/discount-manager)]]]]]))

(defmethod flow/render-screen :web.registry/familydiscount [app-atom _]
  (website/screen-wrapper app-atom
    (registry-discount-manager app-atom)
    {:pagetype :registry}))

(defmethod t/transition-open :web.registry/familydiscount [app-atom _ params]
  (toaster/open-overlay app-atom :web.registry/familydiscount)
  (comms/ajax-get :web.registry/familydiscount (select-keys params [:uuid])))

(defmethod comms/receive :web.registry/familydiscount [app-atom discount]
  (swap! (cmn/process-cursor app-atom) assoc
    :vouchers (:vouchers discount)
    :registry (:registry discount))
  (toaster/close-overlay app-atom :web.registry/familydiscount))